<template>
  <div class="thanks-panel">
    <div class="thanks-panel__inner-container" v-if="isSuccess">
      <h1>Kiitos, tilaamasi hakuvahti on nyt lopetettu</h1>
      <div>
        <a href="/">
          <button class="form-button primary action-btn" type="button">
            <span>Siirry etusivulle</span>
          </button>
        </a>
      </div>
    </div>

    <div class="thanks-panel__inner-container" v-else>
      <h1>Hei, tämä hakuvahti on päättynyt.</h1>
      <p>Voit tehdä uuden vahdin OP Kodin hakusivulla.</p>
      <div>
        <a :href="routepath.apartmentsForSale.path">
          <button class="form-button primary action-btn" type="button">
            <span>Siirry etusivulle</span>
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import * as actions from '@/app/store/action-types';
import * as routepath from '@/app/routes';

export default {
  name: 'Unsubscribe',
  data: () => ({
    isSuccess: false,
    routepath,
  }),
  mounted() {
    this.$store.dispatch(actions.UNSUBSCRIBE, this.$route.query).then((res) => {
      if (res.isSuccess === true) {
        this.isSuccess = true;
      } else {
        this.isSuccess = false;
      }
    });
  },
};
</script>
